'use strict';

import React,{ Component} from 'react';
import CurrencyFormat from 'react-currency-format';
import { Card, CardHeader, CardContent, Box, Typography } from '@material-ui/core';


class miniList extends Component{
    render() {
      //console.log("[DEBUG], Render Class Minichart", this.props.value);
        return (
            <Card id="site-visits" onClick={this.props.ClickOnMenu} style={{cursor: "pointer"}}>
                <CardHeader title={this.props.graphName} />

                <CardContent>
                    <Box p={2} >  
                        <Typography variant="body1">Semaine</Typography>
                        <h3>
                            <CurrencyFormat value={this.props.value1} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>
                        </h3>

                        <br/>

                        <Typography variant="body1">Mois</Typography>
                        <h3>
                            <CurrencyFormat value={this.props.value2} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>
                        </h3>
                        <br/>

                        <Typography variant="body1">Année</Typography>
                        <h3>
                            <CurrencyFormat value={this.props.value3} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>
                        </h3>
                    </Box>
                </CardContent>
            </Card>
        )
    }
};
export default miniList